import { CHAT_TOPICS } from './actions';

export const api_call = (data) => {
  return (dispatch, getState) => {
    dispatch({
      type: CHAT_TOPICS,
      payload: data,
    });
  };
};

export default api_call;
